import { render } from "./CfdiTable.vue?vue&type=template&id=3030c03d&scoped=true"
import script from "./CfdiTable.vue?vue&type=script&lang=js"
export * from "./CfdiTable.vue?vue&type=script&lang=js"

import "./CfdiTable.vue?vue&type=style&index=0&id=3030c03d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3030c03d"]])

export default __exports__